// extracted by mini-css-extract-plugin
export default {"changeFormModal":"ChangeForm_changeFormModal__+iX7R","changeForm":"ChangeForm_changeForm__zJSm8","buttonContainer":"ChangeForm_buttonContainer__u6sU4"};